import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ChatContextType {
	currentChatHistory: any;
	setcurrentChatHistory: (user: any) => void;
	isQuestionAnswer: boolean;
	setIsQuestionAnswer(answer: boolean);
	chats: any;
	setChats: (data: any) => void;
	setIsDisabled: (data: any) => void;
	isDisabled: boolean;
	isNewChat: boolean;
	setIsNewChat: (data) => void;
}

const ChatContext = createContext<ChatContextType | undefined>(undefined);

interface AppProviderProps {
	children: ReactNode;
}

export const ChatProvider = ({ children }: AppProviderProps) => {
	const [currentChatHistory, setcurrentChatHistory] = useState();
	const [chats, setChats] = useState([]);
	const [isDisabled, setIsDisabled]: any = useState(false);
	const [isNewChat, setIsNewChat]: any = useState(true);

	const [isQuestionAnswer, setIsQuestionAnswer]: any = useState(false);

	const value: ChatContextType = {
		currentChatHistory,
		setcurrentChatHistory,
		isQuestionAnswer,
		setIsQuestionAnswer,
		chats,
		setChats,
		setIsDisabled,
		isNewChat,
		setIsNewChat,
		isDisabled,
	};

	return <ChatContext.Provider value={value}>{children}</ChatContext.Provider>;
};

export const useChatContext = () => {
	const context = useContext(ChatContext);
	if (!context) {
		throw new Error('useChatContext must be used within AppProvider');
	}
	return context;
};
